import { AppState } from '../states/app.state';
import { LinkedPostsState } from '../states/linked-posts.state';
import { createSelector } from '@ngrx/store';

const LinkedPostsState = (state: AppState) => state.linkedPosts;

export const selectLinkedPosts = createSelector(
    LinkedPostsState,
    (state: LinkedPostsState) => state.linkedPosts
);
